export default {"src":"/_next/static/media/star.d95713f3.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};